












import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import { CheckTicketCommandHandlerProvider } from '@/Infrastructure/Account/Provider'
import { CheckTicketCommand, AccountDto } from '@/Application/Authentication'

const accountStore = namespace('account')

@Component({})
export default class LoginResponse extends Vue {
  loading = false

  @accountStore.Action
  public setAccountData!: (payload: AccountDto) => void

  get anchorLine (): string {
    return require('@/UI/Assets/birds_anchor_line.png')
  }

  mounted (): void {
    const ticket = this.$route.query.ticket
      ? this.$route.query.ticket.toString()
      : ''

    if (ticket) {
      const provider = new CheckTicketCommandHandlerProvider()
      const command = new CheckTicketCommand(ticket)
      this.loading = true
      const handler = provider.provide()
      handler.handle(command)
        .then((response: AccountDto) => {
          return this.setAccountData(response)
        })
        .then(() => {
          this.$router.push({ name: 'Home' })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
